export const tabOptions = (data) => {
	return [
		{
			key: 'pending',
			tab: 'Por aprobar',
			data: data,
			status: '100',
		},
		{
			key: 'approved',
			tab: 'Aprobada',
			data: data,
			status: '200',
		},
		{
			key: 'completed',
			tab: 'Completada',
			data: data,
			status: '400',
		},
		{
			key: 'rejected',
			tab: 'Rechazada',
			data: data,
			status: '300',
		},
	];
};
